import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SharedModule } from './shared-module/shared-module.module';
import { RequestCreationGuard } from './core/services/request-creation/request-creation-guard.service';
import { RequirementFormPage } from './pages/requirement-form/requirement-form.page';
import { AuthGuard } from './core/services/auth-guard/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'pre-load',
    pathMatch: 'full'
  },
  {
    path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
  }, {
    path: 'requirement-follow-up',
    loadChildren: () => import('./pages/requirement-follow-up/requirement-follow-up.module').then(m => m.RequirementFollowUpPageModule),
    canActivate: [AuthGuard]
  }, {
    path: 'conformity', loadChildren: () => import('./pages/conformity/conformity.module').then(m => m.ConformityPageModule),
    canActivate: [AuthGuard]
  }, {
    path: 'properties', loadChildren: () => import('./pages/properties/properties.module').then(m => m.PropertiesPageModule),
    canActivate: [AuthGuard]
  }, {
    path: 'help-center', loadChildren: () => import('./pages/help-center/help-center.module').then(m => m.HelpCenterPageModule)
  }, {
    path: 'unit', loadChildren: () => import('./pages/unit/unit.module').then(m => m.UnitPageModule),
    canActivate: [AuthGuard]
  }, {
    path: 'test', loadChildren: () => import('./test/test.module').then(m => m.TestPageModule)
  }, {
    path: 'requirement-form',
    component: RequirementFormPage,
    loadChildren: () => import('./pages/requirement-form/requirement-form.module').then(m => m.RequirementFormPageModule),
    canDeactivate: [RequestCreationGuard],
    canActivate: [AuthGuard]
  }, {
    path: 'requests',
    loadChildren: () => import('./pages/requests/requests.module').then(m => m.RequestsPageModule),
    canActivate: [AuthGuard]
  }, {
    path: 'documents/:type',
    loadChildren: () => import('./pages/documents/documents.module').then(m => m.DocumentsPageModule),
    canActivate: [AuthGuard]
  }, /*{
    path: 'send-comments',
    loadChildren: () => import('./pages/send-comments/send-comments.module').then(m => m.SendCommentsPageModule)
  }, */{
    path: 'user-config',
    loadChildren: () => import('./pages/user-config/user-config.module').then(m => m.UserConfigPageModule),
    canActivate: [AuthGuard]
  }, {
    path: 'warranty',
    loadChildren: () => import('./pages/warranty/warranty.module').then(m => m.WarrantyPageModule),
    canActivate: [AuthGuard]
  }, {
    path: 'pre-load',
    loadChildren: () => import('./pages/pre-load/pre-load.module').then(m => m.PreLoadPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule)
  },
  {
    path: 'verify-account',
    loadChildren: () => import('./pages/verify-account/verify-account.module').then(m => m.VerifyAccountPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true }), SharedModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
